// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanAmountPropertyDto
 */
export interface IPlanAmountPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanAmountPropertyDto
     */
    plan_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanAmountPropertyDto
     */
    plan_amount_state?: IPlanAmountPropertyDtoPlanAmountStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPlanAmountPropertyDtoPlanAmountStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IPlanAmountPropertyDto interface.
 */
export function instanceOfIPlanAmountPropertyDto(value: object): value is IPlanAmountPropertyDto {
    return true;
}

export function IPlanAmountPropertyDtoFromJSON(json: any): IPlanAmountPropertyDto {
    return IPlanAmountPropertyDtoFromJSONTyped(json, false);
}

export function IPlanAmountPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanAmountPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_amount': json['plan_amount'] == null ? undefined : json['plan_amount'],
        'plan_amount_state': json['plan_amount_state'] == null ? undefined : json['plan_amount_state'],
    };
}

export function IPlanAmountPropertyDtoToJSON(json: any): IPlanAmountPropertyDto {
    return IPlanAmountPropertyDtoToJSONTyped(json, false);
}

export function IPlanAmountPropertyDtoToJSONTyped(value?: IPlanAmountPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_amount': value['plan_amount'],
        'plan_amount_state': value['plan_amount_state'],
    };
}

